/* Fade-in-on-scroll : ajoute la classe `is-visible` quand l'élément entre dans le viewport. */
(function () {
  // Marque que JS est dispo (les styles initiaux ne s'appliquent que si .js est présent).
  document.documentElement.classList.add('js');

  function init() {
    var targets = document.querySelectorAll('.fade-in-on-scroll:not(.is-visible)');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback : tout révéler.
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    targets.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Pour Shopify theme editor : ré-observer quand une section est rechargée.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
